// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"72ead98b","139":"97fbe230","213":"963d50c4","301":"1086b594","818":"3225aaa9","823":"cfe2db1c","883":"b1d85dc3"}[chunkId] + ".chunk.js";
};